const STORE_KEY = 'TEST'

export const FETCH_TEST = `${STORE_KEY}/FETCH_TEST`
export const FETCH_PROB = `${STORE_KEY}/FETCH_PROB`
export const FETCH_LIST = `${STORE_KEY}/FETCH_LIST`
export const SET_PROBS = `${STORE_KEY}/SET_PROBS`
export const SET_TEST_LIST = `${STORE_KEY}/SET_TEST_LIST`
export const SET_OPTIONS = `${STORE_KEY}/SET_OPTIONS`
export const SET_ERROR = `${STORE_KEY}/SET_ERROR`
export const SET_TIMER = `${STORE_KEY}/SET_TIMER`
export const MOVE_TEST_AFTER = `${STORE_KEY}/MOVE_TEST_AFTER`
export const MOVE_TEST_BEFORE = `${STORE_KEY}/MOVE_TEST_BEFORE`